import React from 'react';
import Logo from '../common/Logo';

interface CampaignComment {
  id: string;
  name: string;
  type: 'support' | 'oppose';
  timeAgo: string;
  message: string;
  isEdited?: boolean;
}

interface CommentFeedProps {
  comments: CampaignComment[];
}

const CommentFeed: React.FC<CommentFeedProps> = ({ comments }) => {
  return (
    <div className="mt-6">
      <div className="space-y-6">
        {comments.map((c) => (
          <div key={c.id} className="flex items-start gap-4">
            <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center border">
              <Logo size="small" />
            </div>

            <div>
              <p className="text-sm font-semibold text-textPrimary">
                {c.name}
                <span
                  className={`ml-2 text-xs px-2 py-0.5 rounded-full ${
                    c.type === 'support'
                      ? 'bg-green-100 text-green-700'
                      : 'bg-red-100 text-red-700'
                  }`}
                >
                  {c.type === 'support' ? 'Supported' : 'Opposed'}
                </span>
              </p>

              <p className="text-xs text-gray-500 mb-1">
                {c.timeAgo}
                {c.isEdited ? ' · Edited' : ''}
              </p>

              <p className="text-sm text-textPrimary leading-snug whitespace-pre-wrap">
                {c.message}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CommentFeed;